import React   from 'react';
import { Link } from 'react-router-dom';
import Utils from '../../utils/Utils';

const handleMouseEnter = (e) => {
	Utils.handleMouseEnter(e)
}

const Settings = (props) => {
	return(<div className="settings">
			<Link  
				id = {props.id}
				onMouseEnter={() => handleMouseEnter(props.id)}
				to={props.link} className="focusable">
					<span className="settings-text">{ props.translations.get('stb_menu_settings', 'Ajustes')}</span>
					<span className="settings-icon fa fa-cog"></span>
			</Link>
		</div>)
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/Social/Settings.jsx